import Command from '@ckeditor/ckeditor5-core/src/command';
import { CkeditorConstants } from '../../src/utils/ckeditorconstants';
import CustomLinkPopup from './../editwebemaillink/customlinkpopup';
import {
  subtemplateUtils,
  checkIsCitation,
  checkSelectedLink,
  enableDisableKeywordOption,
  checkForWhiteSpace,
  checkSelectedComments,
  checkSelectionIncludesComments,
  isSingleSpanSelected,
  checkForMedia,
  checkForTable,
  checkForFigCaption,
  localService
} from "../../src/utils";

const {
  rightClickOptions: {
    INSERT_SUBTEMPLATE,
    GO_TO_LINK_NAME,
    GO_TO_LINK_KEY,
    EDIT_LINK_NAME,
    DELETE_LINK_NAME,
    DELETE_LINK_KEY,
    EDIT_LINK_KEY,
    REMOVE_SUBTEMPLATE,
    DELETE_KEYWORD_KEY,
    LINK_TO,
    COPY_BULLET_LIST_NAME,
    COPY_BULLET_LIST_KEY,
    CUT_BULLET_LIST_NAME,
    CUT_BULLET_LIST_KEY
  },
  helperAttributes: { DATA_UNLOCK, SUBTEMPLATE_NAME, NO_ONE, CONTENTEDITABLE },
  unLockValues: { no_one },
  localStorageItem: { enableInsertBtn, subtemplateObject, LINK_TO_FRAGMENT_AVAILABLE, RHP_CITATION_REF_CLICK, AI_UMC_SECTION_ID },
  htmlElement: { LINK_SPAN, SPAN, DIV, KEYWORD_SPAN },
  attributeWebLink,
  attributeLinkOtherDocument,
  attributeMediaResource,
  subTemplates,
  class: { WK_KEYWORD_REF, section_content },
  htmlAttributes: { CLASS, ID },
  elementClass: { suggestion_deletion_marker }
} = CkeditorConstants;

export default class ContextMenuCommand extends Command {
  execute(val) {
    const editor = this.editor;
    const subTemplateList = JSON.parse(localStorage.getItem('subTemplateList'));
    val.value.preventDefault();
    let isSectionAvailable = false;

    const isAIUMCFeatureEnabled = this.editor.isAIUMCFeatureEnabled;
    const section = val.value.target.closest('section');
    let sectionId = section?.id;
    if (isAIUMCFeatureEnabled && sectionId) {
      sectionId = this._getParentElementSectionId(section, sectionId);
      isSectionAvailable = true;
      localService.set(AI_UMC_SECTION_ID, sectionId);
    }
    /**
     * When user do right click on link the 'elementClicked' is wrong element on Mac OS
     * but if we put this macrotask to the end of queue it has correct value.
     */
    setTimeout(() => {
      let contextmenuObjects = [
        {
          name: INSERT_SUBTEMPLATE,
          isEnabled: JSON.parse(localStorage.getItem(enableInsertBtn)),
          showTree: true,
        },
      ];
      editor.fire('contextmenu');
      const subtemplatesNames = JSON.parse(
        localStorage.getItem(subtemplateObject)
      );
      localService.remove(subtemplateObject);
      localService.remove(enableInsertBtn);
      const rhpCitationRefClicked = JSON.parse(localStorage.getItem(RHP_CITATION_REF_CLICK));
      const balloon = document.querySelector('.ck-balloon-panel_visible');
      rhpCitationRefClicked && balloon && balloon.classList.remove('ck-balloon-panel_visible');
      // Filter templates that aren't in the list of templates
      let filteredSubtemplatesNames = null;
      if (subtemplatesNames) {
        filteredSubtemplatesNames = subtemplatesNames.filter(
          (targetSubtemplateName) =>
            subTemplateList.some(
              (subtemplatesName) =>
                subtemplatesName.name.trim() ===
                targetSubtemplateName.name.trim()
            )
        );
      }
      contextmenuObjects[0].subTemplateObject = filteredSubtemplatesNames;
      if (filteredSubtemplatesNames && !filteredSubtemplatesNames.length) {
        contextmenuObjects[0].isEnabled = false;
        editor.commands.get(subTemplates).isEnabled = false;
      }
      const selection = editor.model.document.selection;
      let elementClicked =
        editor.model.document.selection.getFirstPosition().parent;
      const isWholeLinkSelectedWithText = checkSelectedLink(this.editor);

      // This code checks if the clicked element is a link span. If it is not, it searches for a link span within the clicked element's children and assigns it to the elementClicked variable.
      if (isWholeLinkSelectedWithText && elementClicked.name !== LINK_SPAN) {
        const linkSpanNode = elementClicked._children?._nodes?.find(node => node.name === LINK_SPAN);
        if (linkSpanNode) {
          elementClicked = linkSpanNode;
        }
      }

      if (subtemplatesNames?.length) {
        const isLinkClicked = subtemplateUtils(this.editor, val.value.target);
        const isCitationClicked = checkIsCitation(
          this.editor,
          val.value.target
        );
        const clickedElementPosition = selection.getFirstPosition();
        const isWholeLinkSelected = checkSelectedLink(
          this.editor,
          val.value.target
        );
        /**
         * disable the insert subtemplate option when citation is clicked or click is done in between the link
         */
        if (
          (isLinkClicked &&
            !clickedElementPosition.isAtStart &&
            !clickedElementPosition.isAtEnd) ||
          isCitationClicked ||
          isWholeLinkSelected === false
        ) {
          contextmenuObjects[0].isEnabled = false;
          editor.commands.get(subTemplates).isEnabled = false;
        }
      }

      /**
     * Check whether right clicking on non editable placeholder.
     */
      const target = val?.value?.target;
      const isNonEditableElement =
        target?.tagName === DIV.toUpperCase() &&
        target.getAttribute(NO_ONE) &&
        target.getAttribute(CONTENTEDITABLE) === 'false';

      /**
       * Check for adding 'Link to' option in context menu
       */
      if (localStorage.getItem(LINK_TO_FRAGMENT_AVAILABLE) !== null) {
        this.checkForLinkToOption(contextmenuObjects, editor, selection, isNonEditableElement)
      }
      this.getRightClickedElement({
        editor,
        selection,
        elementClicked,
        contextmenuObjects,
        val,
      });

      /**
      * Check if right-click is on a bullet/list item and add 'Copy Bullet List' option
      */
      this.checkForBulletListCopy(contextmenuObjects, editor, selection);

      if (isSectionAvailable && isAIUMCFeatureEnabled) {
        contextmenuObjects.push({
          isEnabled: this.editor.isAIUMCLoading,
          name: 'Generate AI-UMC',
          sectionIdForUMC: sectionId
        })
      }
      editor.fire("openContextMenu", contextmenuObjects);
    });
  }

  getRightClickedElement(props) {
    const { editor, selection, elementClicked, contextmenuObjects, val } =
      props;
    const { _nodes } = elementClicked._children;
    /**
     * Check whether right clicking on non editable placeholder.
     */
    const isNonEditableElement =
      val &&
      val.value &&
      val.value.target.tagName === DIV.toUpperCase() &&
      val.value.target.getAttribute(NO_ONE) &&
      val.value.target.getAttribute(CONTENTEDITABLE) === 'false';
    const getSubTemplateInfo =
      this.isRightClickOnSubtempElement(elementClicked);
    if (!isNonEditableElement && getSubTemplateInfo.isSubtemplateAvailable) {
      const mapper = this.editor.editing.mapper;
      const subtemplateEl = getSubTemplateInfo.subtemplateViewElement;
      /**
       * Resolve the actual subtemplate view element with data-subtemplate-name attribute.
       * instead of the subtemplate itself, so we check the parent as a fallback.
       * If neither has the attribute (non-subtemplate click), targetItem is null and
       * we skip adding the "Remove Subtemplate" option entirely.
       * (click outside subtemplate — option not visible)
       */
      const targetItem = subtemplateEl?.hasAttribute?.('data-subtemplate-name')
        ? subtemplateEl
        : subtemplateEl?.parent?.hasAttribute?.('data-subtemplate-name') ? subtemplateEl.parent : null;

      if (targetItem) {
        const shouldEnableRemoveSubtemplateOption = this.shouldEnableRemoveSubtemplate(targetItem, mapper);

        contextmenuObjects.push({
          name: REMOVE_SUBTEMPLATE,
          isEnabled: shouldEnableRemoveSubtemplateOption,
          showTree: false,
          deletableSubTempRange: getSubTemplateInfo.deletableSubTempRange,
        });
      }
    }
    if (this.getLinkedElement(elementClicked)) {
      let newTextContent = '';
      let textContent = _nodes[0]._data;
      if (_nodes.length > 0) {
        _nodes.forEach((ele) => {
          newTextContent += ele._data;
        });
        textContent = newTextContent;
      }
      const link = elementClicked.getAttribute('resource');
      const typeOf = elementClicked.getAttribute('typeof');
      const linkEvent = this.getCustomLinkEvent(
        link,
        textContent,
        typeOf,
        selection,
        !editor.isReadOnly
      );
      const linkViewElement = this.editor.editing.mapper.toViewElement(elementClicked);
      contextmenuObjects.push(...this.getLinkOptions(link, linkEvent, linkViewElement));
    } else {
      const children = selection.getFirstPosition().parent.getChildren();
      for (let child of children) {
        const {
          value: { target },
        } = val;
        const { _attrs } = child;
        if (
          child.hasAttribute('linkHref') &&
          child._data === target.firstChild.data
        ) {
          const textContent = target.firstChild.textContent;
          const link = _attrs.get('linkHref');
          const typeOf =
            target.getAttribute('typeof') ||
            target.parentElement.getAttribute('typeof');
          const idUnique = target.getAttribute('id');
          const linkEvent = this.getCustomLinkEvent(
            link,
            textContent,
            typeOf,
            selection,
            !editor.isReadOnly
          );
          linkEvent['idUnique'] = idUnique;
          const childViewElement = this.editor.editing.mapper.toViewElement(child);
          contextmenuObjects.push(
            ...this.getLinkOptions(link, linkEvent, childViewElement)
          );
          break;
        }
      }
    }
    /*
     * Check whether right clicking on keyword and show context menu
     */
    const isWholeKeywordSelected = enableDisableKeywordOption(this.editor);
    let isSelection = false;
    const { isAtEnd, isAtStart } = selection.getFirstPosition();
    const parentClass = elementClicked.parent.getAttribute(CLASS);
    if (isWholeKeywordSelected) {
      const element = editor.model.getSelectedContent(selection);
      const {
        _children: { _nodes: elementNode },
      } = element;
      if (elementNode.length > 1) {
        for (let i = 0; i < elementNode.length; i++) {
          if (elementNode[i].getAttribute(CLASS) === WK_KEYWORD_REF) {
            isSelection = true;
            break;
          }
        }
        return isSelection;
      } else if (
        (_nodes.length > 0 &&
          _nodes[0].getAttribute(CLASS) === WK_KEYWORD_REF) ||
        elementClicked.getAttribute(CLASS) === WK_KEYWORD_REF ||
        parentClass === WK_KEYWORD_REF
      ) {
        isSelection = true;
      }

      if (isSelection) {
        contextmenuObjects.push(this.getKeywordOption());
      } else if (
        (elementClicked.getAttribute(CLASS) === WK_KEYWORD_REF ||
          (_nodes.length > 0 &&
            _nodes[0].getAttribute(CLASS) === WK_KEYWORD_REF)) &&
        !isAtStart && !isAtEnd
      ) {
        contextmenuObjects.push(this.getKeywordOption());
      } else {
        contextmenuObjects[0].isEnabled = false;
        editor.commands.get(subTemplates).isEnabled = false;
      }
    } else if (
      (elementClicked.parent.name === KEYWORD_SPAN ||
        parentClass === WK_KEYWORD_REF) &&
      !isAtStart &&
      !isAtEnd
    ) {
      contextmenuObjects.push(this.getKeywordOption());
    }
  }

  getSuggestionIdFromMarkerName(markerName) {
    return _.find(
      _.split(markerName, ':'), (markerNameSubString) => _.find(
        this.editor.plugins.get('TrackChangesEditing')?.getSuggestions(), suggestion => suggestion.id === markerNameSubString
      )
    );
  }

  checkForLinkToOption(contextmenuObjects, editor, selection, isNonEditableElement) {
    let isEnable = false;
    if (!selection.isCollapsed && !isNonEditableElement
      && !enableDisableKeywordOption(editor)
      && !checkForMedia(editor)
      && !checkForWhiteSpace(editor)
      && !checkSelectedComments(editor)
      && !checkSelectionIncludesComments(editor)
      && isSingleSpanSelected(editor)
      && !checkForTable(editor) && !checkForFigCaption(editor)) {
      isEnable = true;
    } else {
      isEnable = false;
    }
    contextmenuObjects.push(
      {
        name: LINK_TO,
        isEnabled: isEnable,
        showTree: false,
        key: LINK_TO,
      }
    );
  }

  /**
   * Checks if right-click is on a list item. If so, finds the entire contiguous
   * list (including nested sub-bullets) and adds a 'Copy Bullet List' context menu option
   * with the range covering all list items.
   */
  checkForBulletListCopy(contextmenuObjects, editor, selection) {
    // If editor instance belongs RHP then return
    if (!editor?.editing?.view?.domRoots?.get("main")?.querySelector?.(
      `.istemplatedoc`
    )) {
      return;
    }
    const clickedBlock = selection.getFirstPosition().parent;

    // Walk up to find the nearest ancestor that is a list item
    let listItem = clickedBlock;
    while (listItem && !listItem.hasAttribute('listType')) {
      listItem = listItem.parent;
    }

    if (!listItem) {
      return;
    }

    // Find the top-level indent of this list group (walk back to indent 0)
    let startItem = listItem;
    let prev = startItem.previousSibling;
    while (prev && prev?.hasAttribute?.('listType')) {
      startItem = prev;
      prev = startItem.previousSibling;
    }

    // Walk forward to find the last item in the contiguous list (all indent levels)
    let endItem = listItem;
    let next = endItem.nextSibling;
    while (next && next?.hasAttribute?.('listType')) {
      endItem = next;
      next = endItem.nextSibling;
    }

    // Build range covering the entire list block (including nested sub-bullets)
    editor.model.change((writer) => {
      const range = writer.createRange(
        writer.createPositionBefore(startItem),
        writer.createPositionAfter(endItem)
      );
      [
        { name: COPY_BULLET_LIST_NAME, key: COPY_BULLET_LIST_KEY },
        { name: CUT_BULLET_LIST_NAME, key: CUT_BULLET_LIST_KEY }
      ].forEach(({ name, key }) => {
        contextmenuObjects.push({
          name,
          isEnabled: true,
          showTree: false,
          key,
          bulletListRange: range,
        });
      });
    });
  }

  getLinkedElement(elementClicked) {
    const {
      attributeLinkingTypes,
      linksTo,
      htmlElement: { SPAN },
    } = CkeditorConstants;
    const rel = elementClicked.getAttribute('rel');

    return !!(
      rel &&
      attributeLinkingTypes &&
      (elementClicked.name === LINK_SPAN || elementClicked.name === SPAN) &&
      rel === linksTo &&
      attributeLinkingTypes.includes(elementClicked.getAttribute('typeof'))
    );
  }

  getCustomLinkEvent(linkAddress, linkText, typeOf, selection, isEdit) {
    let id =
      typeOf === attributeWebLink
        ? 'webemaillink'
        : (typeOf === attributeLinkOtherDocument ||
          typeOf === attributeMediaResource) && !linkAddress.includes('#')
          ? 'linktoanotherdocument'
          : 'linktofragment';
    return new CustomLinkPopup(linkAddress, linkText, id, selection, isEdit);
  }

  getLinkOptions(link, customLinkEvent, linkElement) {
    // Check if link or its children have deletion marker class
    const isLinkMarkedForDeletion = linkElement?.getAttribute?.('class')?.includes(suggestion_deletion_marker) ||
      Array.from(linkElement?.getChildren?.() || []).some(child => child.getAttribute?.('class')?.includes(suggestion_deletion_marker));

    const deleteLinkOption = [
      {
        name: DELETE_LINK_NAME,
        isEnabled: !isLinkMarkedForDeletion,
        showTree: false,
        key: DELETE_LINK_KEY,
        link,
      },  
    ];

    if (customLinkEvent.id === 'linktofragment') {
      return [
        {
          ...deleteLinkOption[0],
          customLinkEvent,
        },
      ];
    }

    return [
      {
        name: GO_TO_LINK_NAME,
        isEnabled: true,
        showTree: false,
        key: GO_TO_LINK_KEY,
        link,
      },
      {
        name: EDIT_LINK_NAME,
        isEnabled: true,
        showTree: false,
        key: EDIT_LINK_KEY,
        link,
        customLinkEvent,
      },
      {
        ...deleteLinkOption[0],
        customLinkEvent,
      },
    ];
  }

  getKeywordOption() {
    return {
      name: DELETE_LINK_NAME,
      isEnabled: true,
      showTree: false,
      key: DELETE_KEYWORD_KEY,
    };
  }

  isRightClickOnSubtempElement(element) {
    const toViewEle = this.editor.editing.mapper.toViewElement(element);
    const getAncestors = toViewEle.getAncestors();
    const isSubtemplate = getAncestors.filter((item) =>
      item.hasAttribute(SUBTEMPLATE_NAME)
    );

    /**
     * True if user has right clicked on inline subtemplate
     */
    if (!isSubtemplate.length) {
      for (const child of toViewEle.getChildren()) {
        if (child.name === SPAN && child.hasAttribute(SUBTEMPLATE_NAME)) {
          isSubtemplate.push(toViewEle);
          break;
        }
      }
    }
    let range = null;

    if (isSubtemplate.length) {
      const toModelElement = this.editor.editing.mapper.toModelElement(
        isSubtemplate[isSubtemplate.length - 1]
      );

      this.editor.model.change((writer) => {
        const isSectionSiblings = this.isSiblingsSectionContent(toModelElement);
        const previousSiblingPos = toModelElement.previousSibling
          && writer.createPositionBefore(toModelElement.previousSibling);
        if (isSectionSiblings) {
          range = writer.createRangeIn(toModelElement);
        } else {
          // Non-editable parent element - range In subtemplate added
          // Editable parent element - range On the subtemplate added
          range =
            previousSiblingPos &&
              toModelElement.parent?.getAttribute?.(DATA_UNLOCK) === no_one
              ? writer.createRangeIn(toModelElement)
              : writer.createRangeOn(toModelElement);
        }
      });
    }
    const subtemplateViewElement = isSubtemplate.length ? isSubtemplate[isSubtemplate.length - 1] : null;
    this.editor.selectedSubtemplateId = subtemplateViewElement?._attrs?.get(ID);
    return {
      deletableSubTempRange: range,
      isSubtemplateAvailable: range ? true : false,
      subtemplateViewElement,
    };
  }

  isSiblingsSectionContent(element) {
    try {
      return (
        element.parent.getAttribute?.(DATA_UNLOCK) === no_one &&
        element.previousSibling?.getAttribute?.(CLASS)?.includes(section_content) &&
        element.nextSibling?.getAttribute?.(CLASS)?.includes(section_content)
      );
    } catch {
      return false;
    }
  }

  /**
   * Determines whether the "Remove Subtemplate" context menu option should be enabled.
   * Returns true (enabled) if no matching deletion suggestion is found for this subtemplate.
   * Returns false (disabled) if the subtemplate is already entirely delete-marked.
   *
   * Only checks suggestions with removeSubtemplate flag — partial text deletions,
   * insertions, and format changes are ignored so they don't wrongly disable the option.
   *
   * @param {Object} targetItem - The view element of the right-clicked subtemplate
   
   */
  shouldEnableRemoveSubtemplate(targetItem, mapper) {
    const targetName = targetItem.getAttribute('data-subtemplate-name');
    const targetModel = mapper.toModelElement(targetItem);

    const isAlreadyDeleted = targetName && _.some(
      this.editor.plugins.get('TrackChangesEditing').getSuggestions({ skipNotAttached: true }),
      (suggestion) => {
        // Skip non-deletion suggestions and suggestions without removeSubtemplate flag
        if (suggestion.type !== 'deletion' || !suggestion?.attributes?.commandParams?.removeSubtemplate) return false;
        return [...suggestion.getItems()].some(item => {
          // Direct Model Match: item is the subtemplate itself or a direct child of it
          if (item === targetModel || item?.parent === targetModel) return true;
          const viewItem = mapper.toViewElement(item);
          // Subtemplate Boundary Check & Nested Subtemplate Guard:
          // - If item is itself a subtemplate, match only if it's the SAME one
          // - If item's parent belongs to a DIFFERENT/nested subtemplate, skip it
          const parentViewItem = mapper.toViewElement(item?.parent);
          if (viewItem?.hasAttribute?.('data-subtemplate-name') ||
            (parentViewItem?.hasAttribute?.('data-subtemplate-name') && parentViewItem !== targetItem)) {
            return viewItem === targetItem;
          }
          return false;
        });
      }
    );
    return !isAlreadyDeleted;
  }

  /**
   * Recursively get the section id from parent elements
   * @param {HTMLSelectElement} element
   * @param {string} id
   * @returns {string} id
   */
  _getParentElementSectionId(element, id) {
    if (!element.parentElement) {
      return id;
    } else {
      const parentElement = element.parentElement;
      if (parentElement.tagName === 'CKEDITOR') {
        return id;
      }
      if (parentElement.tagName.toLowerCase() === 'section' && parentElement.id) {
        return (id = parentElement.id);
      }
      return this._getParentElementSectionId(parentElement, id);
    }
  }
}
